import React, { Component } from 'react'

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Forside from './forside'
import Planlegging from './planlegging/planleggingContainer'
import Utskiftning from './utskiftning/utskiftningContainer'
import Arbeidsliste from './planlegging/arbeidsliste/arbeidslisteContainer'
import RedigerArbeidsliste from './planlegging/arbeidsliste/rediger/rediger'
import ArbeidslisteAktiv from './utskiftning/arbeidsliste-aktiv-container'
import VannmaalerContainer from './utskiftning/vannmaalere/vannmaalerContainer'
import IkkeSkiftetMaaler from './utskiftning/vannmaalere/ikkeskiftetmaaler'
import Maalertyper from './innstillinger/maalertyper'
import SmsInnstillinger from './innstillinger/sms'
import ArbeidslisteInnstillinger from './innstillinger/arbeidslister'
import Innstillinger from './innstillinger'
import Rapporter from './rapporter'
import Login from './felles/login'
import LoginCallback from './felles/login-callback'
import { DefaultLayout, FullscreenLayout } from './felles/layout'
import Hjelp from './felles/Hjelp/hjelp'

export default class RouteAuth extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <DefaultLayout exact path="/planlegging/:ListeId" component={Arbeidsliste} />
                    <FullscreenLayout
                        exact
                        path="/planlegging/rediger/:ListeId"
                        component={RedigerArbeidsliste}
                    />

                    <DefaultLayout
                        exact
                        path="/utskiftning/:ListeId"
                        component={ArbeidslisteAktiv}
                    />
                    <DefaultLayout
                        exact
                        path="/utskiftning/:ListeId/vannmaaler/:Id"
                        component={VannmaalerContainer}
                    />
                    <DefaultLayout
                        exact
                        path="/utskiftning/:ListeId/vannmaaler/:Id/ikkeSkiftet"
                        component={IkkeSkiftetMaaler}
                    />
                    
                    <DefaultLayout
                        exact
                        path="/planlegging"
                        name="Planlegging"
                        component={Planlegging}
                    />
                    <DefaultLayout
                        exact
                        path="/utskiftning"
                        name="Utskiftning"
                        component={Utskiftning}
                    />
                    <DefaultLayout exact path="/forside" component={Forside} />
                    <DefaultLayout exact path="/innstillinger" component={Innstillinger} />
                    <DefaultLayout exact path="/innstillinger/maalere" component={Maalertyper} />
                    <DefaultLayout exact path="/innstillinger/sms" component={SmsInnstillinger} />
                    <DefaultLayout
                        exact
                        path="/innstillinger/arbeidslister"
                        component={ArbeidslisteInnstillinger}
                    />
                    <DefaultLayout exact path="/rapporter/" component={Rapporter} />
                    <DefaultLayout exact path="/Hjelp" component={Hjelp} />
                    <Route exact path="/" component={Login} />
                    <Route exact path="/login" component={LoginCallback} />

                    <Route render={() => <h3>Ikke noe her</h3>} />
                </Switch>
            </Router>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routeAuthClass.jsx